import classNames from 'classnames';
import { useImmersiveHeader } from '../../../supreme-header/use-immersive-header';
import styles from './detail-hero.module.css';
import metaStyles from './detail-meta.module.css';
import ghostStyles from './detail-hero-ghost.module.css';

/** Loading placeholder laid out with `DetailHero`'s own classes, so nothing jumps when the page loads. */
export function DetailHeroGhost() {
    // Transparent header while loading too, so it doesn't switch from solid when the hero arrives.
    useImmersiveHeader();

    return (
        <div className={styles['detail-hero']} aria-hidden="true">
            <div className={classNames(styles['detail-hero__cover'], 'shimmer')} />
            <div className={styles['detail-hero__text']}>
                <div className={classNames(ghostStyles['detail-hero-ghost__title'], 'shimmer')} />
                <div className={ghostStyles['detail-hero-ghost__lines']}>
                    <div className={classNames(ghostStyles['detail-hero-ghost__line'], 'shimmer')} />
                    <div className={classNames(ghostStyles['detail-hero-ghost__line'], 'shimmer')} />
                </div>
                <div className={classNames(metaStyles['detail-meta'], styles['detail-hero__meta'])}>
                    <div className={classNames(ghostStyles['detail-hero-ghost__pill'], 'shimmer')} />
                    <div className={classNames(ghostStyles['detail-hero-ghost__pill'], 'shimmer')} />
                    <div className={classNames(ghostStyles['detail-hero-ghost__pill'], 'shimmer')} />
                </div>
            </div>
            <div className={styles['detail-hero__actions']}>
                <div className={styles['detail-hero__primary']}>
                    <div className={classNames(ghostStyles['detail-hero-ghost__button'], 'shimmer')} />
                    <div className={classNames(ghostStyles['detail-hero-ghost__button'], 'shimmer')} />
                </div>
                <div className={styles['detail-hero__secondary']}>
                    <div className={classNames(ghostStyles['detail-hero-ghost__icon'], 'shimmer')} />
                    <div className={classNames(ghostStyles['detail-hero-ghost__icon'], 'shimmer')} />
                </div>
            </div>
        </div>
    );
}

export default DetailHeroGhost;
